module.exports = __webpack_public_path__ + "static/media/Elena_Tisato.0d28a72c.jpg";